import type { AccumulationChart, IPointRenderEventArgs } from '@syncfusion/ej2-charts';
import type { EmitType } from '@syncfusion/ej2-base';

export async function piechart(appendTo: string, data: any, totalCalories: number) {

    await import('./loadSyncfusion');

    const { AccumulationChart, PieSeries, AccumulationDataLabel, AccumulationLegend, AccumulationTooltip, AccumulationAnnotation } = await import('@syncfusion/ej2-charts');

    AccumulationChart.Inject(PieSeries, AccumulationDataLabel, AccumulationLegend, AccumulationTooltip, AccumulationAnnotation);

    let seriesColor: string[] = ['#FFA500', '#00BFFF', '#FF4500', '#32CD32'];

    let pointRender: EmitType<IPointRenderEventArgs> = (args: IPointRenderEventArgs): void => {
        args.fill = seriesColor[args.point.index % seriesColor.length];
    };

    // Check if total calories are 0
    if (totalCalories === 0) {
        data = [{ x: 'Empty', y: 1 }];
        seriesColor = ['#FFF'];  // White color for the donut
    }

    let pie: AccumulationChart = new AccumulationChart({
        series: [
            {
                dataSource: data,
                xName: 'x',
                yName: 'y',
                innerRadius: '90%',
                dataLabel: {
                    visible: false
                },
                radius: '90%',
                explode: false,
            }
        ],
        enableBorderOnMouseMove: false,
        pointRender: pointRender,
        tooltip: {
            enable: false,
        },
        legendSettings: {
            visible: false
        },
        enableSmartLabels: true,
        center: { x: '45%', y: '45%' }, // Original center coordinates
        annotations: [
            {
                content: `<div style="font-size: 14px; color: #FFF; font-weight: bold; text-align: center;">${totalCalories}<br>Kcal</div>`,
                region: 'Series',
                x: '50%',
                y: '50%'
            }
        ],
        title: '',
        height: '90%',
        width: '90%'
    });

    pie.appendTo(appendTo);
}
